module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Obersiggenthal_AG-f33181bf106c0a7086ae4d3bcc58df89.svg";